import axios from "axios";

const API_URL = process.env.REACT_APP_BASE_URL_API;
const token = `Bearer ` + localStorage.getItem('token');
// const createdBy = localStorage.getItem('userId');
// const updatedBy = localStorage.getItem('userId');
// const mailRoomId = localStorage.getItem('mailRoomId');
// const branch = (localStorage.userDetails) ? JSON.parse(localStorage.userDetails).branch : "";
const config = {
  headers: {
    'Authorization': token,
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
  }
};

const generateinwardreport = async (bodyParamter: any, ReportTypeId: number) => {
  // const tCode = Date.now().toString();
  var reportlink = "";
  if (ReportTypeId === 1) { reportlink = "inwardlog/generatereport/" } else if (ReportTypeId === 2) { reportlink = "inwarddetail/generatereport/" } else if (ReportTypeId === 3) { reportlink = "inwarddetail/generatedeliveryreport/" } else if (ReportTypeId === 4) { reportlink = "inwarddetail/generatependingreport/" }
  else if (ReportTypeId === 5) { reportlink = "inwarddetail/undeliveryreport/" } else if (ReportTypeId === 6) { reportlink = "inwarddetail/generateredirectreport/" } else if (ReportTypeId === 7) { reportlink = "inwarddetail/onholdreport/" }
  else if (ReportTypeId === 8) { reportlink = "inwarddetail/unclaimreport/" } else if (ReportTypeId === 9) { reportlink = "inwarddetail/regulatoryreport/" } 
  return await axios.post(API_URL + reportlink, bodyParamter, config).then(
    (data) => {
      if (data.data.statuscode === '200') {
        return data.data.message;
      }
    }
  ).catch(error => console.log(error))
}
const showinwardreport = async (bodyParamter: any, ReportTypeId: number) => {
  // const tCode = Date.now().toString();
  var reportlink = "";
  if (ReportTypeId === 1) { reportlink = "inwardlog/showreport/" } else if (ReportTypeId === 2) { reportlink = "inwarddetail/showreport/" } else if (ReportTypeId === 3) { reportlink = "inwarddetail/showdeliveryreport/" } else if (ReportTypeId === 4) { reportlink = "inwarddetail/showpendingreport/" }
  else if (ReportTypeId === 5) { reportlink = "inwarddetail/showundeliveryreport/" } else if (ReportTypeId === 6) { reportlink = "inwarddetail/showredirectreport/" } else if (ReportTypeId === 7) { reportlink = "inwarddetail/showonholdreport/" }
  else if (ReportTypeId === 8) { reportlink = "inwarddetail/showunclaimreport/" } else if (ReportTypeId === 9) { reportlink = "inwarddetail/showregulatoryreport/" } 
  return await axios.post(API_URL + reportlink, bodyParamter, config).then(
    (data) => {
      if (data.data.statuscode === '200') {
        return data.data.message;
      }
    }
  ).catch(error => console.log(error))
}


const generateoutwardreport = async (bodyParamter: any, ReportTypeId: number) => {
  var reportlink = "";
  if (ReportTypeId === 1) { reportlink = "outwarddetail/generatereport/" } else if (ReportTypeId === 2) { reportlink = "outwarddetail/generatedeliveryreport/" } else if (ReportTypeId === 3) { reportlink = "outwarddetail/generateintransitreport/" } else if (ReportTypeId === 4) { reportlink = "outwarddetail/generatebillingreport/" }
  else if (ReportTypeId === 5) { reportlink = "outwarddetail/generatertoreport/" } 
  return await axios.post(API_URL + reportlink, bodyParamter, config).then(
    (data) => {
      if (data.data.statuscode === '200') {
        return data.data.message;
      }
    }
  ).catch(error => console.log(error))
}

const generatemisreport = async (bodyParamter: any) => {
  
  console.log(bodyParamter)
 return await axios.post(API_URL + "misreport/getreportbymail/", bodyParamter, config).then(
    (data) => {
      if (data.data.statuscode === '200' && data.data.message) {
        return data.data.message;
      }else{
        return data.data.statuscode
      }
    }
  ).catch(error => console.log(error))
}

const generateadminmaterialreport = async (bodyParamter: any) => {
  return await axios.post(API_URL + "adminmaterial/generatereport", bodyParamter, config).then(
     (data) => {
       console.log(data)
       if (data.data.statuscode === '200' && data.data.message) {
         return data.data.message;
       }else{
         return data.data.statuscode
       }
     }
   ).catch(error => console.log(error))
 }

const ReportService = {
  generateinwardreport,
  showinwardreport,
  generateoutwardreport,
  generatemisreport,
  generateadminmaterialreport
}

export default ReportService;